import { ActionTree } from "vuex";
import { StateInterface } from "src/store";
import { IMediaPlansStateInterface } from "./state";
import API from "src/services/api/api";
import {
  IOptionMimicry,
  IOptionsMimicry,
} from "src/modules/mediaplans/models/mediaplans";

const actions: ActionTree<IMediaPlansStateInterface, StateInterface> = {
  async fetchMediapans({ commit }) {
    const data = await API.goalify.list_mediaplans();
    commit("setMediaplans", data);
  },

  async fetchEmoji({ commit, getters }) {
    try {
      if (!getters.getEmojis.length) {
        const emojis = await API.goalify.get_settings();
        commit("setEmojis", emojis);
      }
    } catch (e) {}
  },

  async fetchOptionMimicry({ commit, getters }, key: keyof IOptionsMimicry) {
    if (getters.getOptionsMimicry[key]?.length) {
      return;
    }
    let options: IOptionMimicry[] = [];
    if (key === "mental_guid") {
      try {
        options = await API.sqlr.idom_get_mental();
      } catch (e) {}
    }
    if (key === "nation_guid") {
      try {
        options = await API.sqlr.idom_get_nation();
      } catch (e) {}
    }
    if (key === "humorism_guid") {
      try {
        options = await API.sqlr.idom_get_humorism();
      } catch (e) {}
    }
    if (key === "agression_guid") {
      try {
        options = await API.sqlr.idom_get_aggression();
      } catch (e) {}
    }
    if (key === "brevity_guid") {
      try {
        options = await API.sqlr.idom_get_brevity();
      } catch (e) {}
    }
    if (key === "ideology_guid") {
      try {
        options = await API.sqlr.idom_get_ideology();
      } catch (e) {}
    }
    if (options.length) {
      commit("setOptionsMimicry", { type: key, options });
    }
  },
};

export default actions;
